import { useLocation } from "react-router-dom";
import "../css/ShareModal.css";
import { RiShare2Line } from "react-icons/ri";
import { RWebShare } from "react-web-share";

const ShareModal = () => {
  const location = useLocation();
  const currentUrl = `${window.location.origin}${location.pathname}`;
  const title = location.pathname.split("/").filter(Boolean).pop().split("-").join(" ");
  console.log("currentUrl", currentUrl);
  console.log("title", title);
  return (
    <>
      <RWebShare
        data={{
          text: `Check out this article: ${title}! 🔥`,
          url: `${currentUrl}`,
          title: `${title}`,
        }}
        onClick={() => console.log("shared successfully!")}
      >
        <button className="open-share-modal"><RiShare2Line className="share-icon"/> Share</button>
      </RWebShare>
    </>
  );
};

export default ShareModal;
